import React, { useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X } from 'lucide-react';
interface LegalModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
}
export function LegalModal({
  isOpen,
  onClose,
  title,
  children
}: LegalModalProps) {
  // Prevent body scroll when modal is open
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isOpen]);
  return <AnimatePresence data-id="element-256">
      {isOpen && <>
          {/* Backdrop */}
          <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} onClick={onClose} className="fixed inset-0 bg-black/40 backdrop-blur-sm z-50 transition-opacity" aria-hidden="true" data-id="element-257" />

          {/* Modal Container */}
          <div className="fixed inset-0 z-50 flex items-center justify-center p-4 sm:p-6 pointer-events-none" data-id="element-258">
            <motion.div initial={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} animate={{
          opacity: 1,
          scale: 1,
          y: 0
        }} exit={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} transition={{
          type: 'spring',
          duration: 0.5,
          bounce: 0.3
        }} className="w-full max-w-2xl bg-[#FDFBF7] rounded-2xl shadow-2xl max-h-[85vh] flex flex-col pointer-events-auto border border-[#2D2A26]/10" role="dialog" aria-modal="true" aria-labelledby="modal-title" data-id="element-259">
              {/* Header */}
              <div className="flex items-center justify-between p-6 border-b border-[#2D2A26]/10 bg-white/50 rounded-t-2xl" data-id="element-260">
                <h2 id="modal-title" className="text-2xl font-bold font-serif text-[#2D2A26]" data-id="element-261">
                  {title}
                </h2>
                <button onClick={onClose} className="p-2 text-[#2D2A26]/60 hover:text-[#2D2A26] hover:bg-[#2D2A26]/5 rounded-full transition-colors" aria-label="Close modal" data-id="element-262">
                  <X className="w-6 h-6" data-id="element-263" />
                </button>
              </div>

              {/* Content */}
              <div className="p-6 overflow-y-auto prose prose-stone max-w-none prose-headings:font-serif prose-headings:text-[#2D2A26] prose-p:text-[#2D2A26]/80 prose-li:text-[#2D2A26]/80" data-id="element-264">
                {children}
              </div>

              {/* Footer */}
              <div className="p-4 border-t border-[#2D2A26]/10 bg-white/50 rounded-b-2xl flex justify-end" data-id="element-265">
                <button onClick={onClose} className="px-6 py-2 bg-[#2D2A26] text-white rounded-full font-medium hover:bg-[#2D2A26]/90 transition-colors text-sm" data-id="element-266">
                  Close
                </button>
              </div>
            </motion.div>
          </div>
        </>}
    </AnimatePresence>;
}